import styled from '@emotion/styled'
import { breakpointFromProps, BreakPointProps } from '../../__styling'
import { ThemeMargins } from '../../__styling/settings/metrics'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export type VerticalGuttersType = [
    keyof ThemeMargins | number,
    keyof ThemeMargins | number,
]

export const StyledPicture = styled('picture')({
    display: 'block',
    '& img': {
        display: 'block',
        width: '100%',
    },
})

export const StyledImageBanner = styled('div')<{
    imgStyles?: BreakPointProps
    extraStyles?: BreakPointProps
}>(({ extraStyles, imgStyles }) => ({
    ...breakpointFromProps(extraStyles || {}),

    img: {
        ...breakpointFromProps(imgStyles || {}),
    },
}))

export const StyledImageBannerWrapper = styled('p')<{
    verticalGutters?: VerticalGuttersType
}>(({ verticalGutters, theme }) => {
    return {
        borderRadius: calcRem(6),
        overflow: 'hidden',
        margin: 0,
        marginTop: calcRem(
            verticalGutters
                ? typeof verticalGutters[0] === 'number'
                    ? verticalGutters[0]
                    : theme.margins[verticalGutters[0]]
                : 0,
        ),
        marginBottom: calcRem(
            verticalGutters
                ? typeof verticalGutters[1] === 'number'
                    ? verticalGutters[1]
                    : theme.margins[verticalGutters[1]]
                : 0,
        ),
    }
})
